<template>
  <el-dialog
  :title="defaultTitleText"
  :visible.sync="visible"
  width="30%"
  :close-on-click-modal="false"
  :close-on-press-escape="false"
  :show-close="false"
  center>
  <div class="text-center">
    <span style="word-break:break-word;">{{defaultContentText}}</span><br>
    <span class="fs-40 " style="text-align:center;width:100%"><i class="el-icon-loading text-center"></i></span>
  </div>
</el-dialog>
</template>
<script>
export default {
	name: 'Waiting-dialog',
  props: {
    content : String,
    visible : Boolean,
    title : {
      type : String
    }
  },
	data() {
		return {

		}
	},
  computed: {
    defaultTitleText() {
      if (this.title != null) {
        return this.title;
      }
      return this.$i18n.t('common.workInProgress');
    },
    defaultContentText() {
      if (this.content != null) {
        return this.content;
      }
      return this.$i18n.t('common.workInProgressContent');
    },
  },
	methods: {
    open(){

    }
  },
  mounted() {

  }
}
</script>
<style>
</style>
